import React, {useEffect, useState} from "react";
import clubService from "../../clubs/services/ClubService";
import CancellationService from "../services/CancellationService";
import InputGroup from "../../forms/components/InputGroup/InputGroup";
import Select from "react-select";
import cancelDetails from "../models/CancelDetails";
import CancellationFormComponent from "./CancellationForm.component";
import {CancellationProcessContext} from "./CancellationProcess.component";
import LoadingComponent from "../../forms/components/LoadingComponent/LoadingComponent";
import {AuthContext} from "../../member/components/AuthContext";
import {Member} from "../../member/models/Member";
import CancelDetails from "../models/CancelDetails";
import {withNamespaces} from "react-i18next";

const CancellationTestComponent = (props) => {
  const [club, setClub] = useState(null);
  const [memberId, setMemberId] = useState('');
  const [member, setMember] = useState();
  const [loading, setLoading] = useState(false);
  const [cancelDetails, setCancelDetails] = useState(null);
  const [clubs, setClubs] = useState([]);

  useEffect(() => {
    clubService.getAllClubs().then(c => {
      console.log('clubs', c);
      setClubs(c.map(c => ({id: c.id, label: c.name})))
    });
  }, []);

  const getCancelDetails = () => {
    setLoading(true);
    CancellationService.getTestCancellationStatus(club.id, memberId).then(details => {
      setCancelDetails(new CancelDetails(details));
      setMember(new Member(details.member));
    })
      .catch(e => {
        setCancelDetails(null)
      }).finally(() => setLoading(false));
  };

  console.log('TestCancellation', member, cancelDetails)
  return (
    <div>
      {loading && <LoadingComponent isVisible={loading}/>}
      <div className='form-group'>
        <InputGroup id="state"
                    className={"form-select"}
                    topLabel={true}
                    label={"Select Club"}>
          <Select
            id="club"
            name="club"
            className={"form-select"}
            classNamePrefix={"form-select"}
            options={
              clubs
            }
            placeholder={"Select club"}
            value={club}
            onChange={(e) => {setClub(e) }}
          />
        </InputGroup>
      </div>

      <div className='form-group'>
        <InputGroup id={'cancellation-offer-comment'} label={'Member ID in MMS'} topLabel={true}>
          <input placeholder={'Member ID in MMS'} type="text"
                 value={memberId || ''} onChange={e => setMemberId(e.target.value)}/>
        </InputGroup>
      </div>

      <div className='form-group'>
        <button className='form-main-button white-with-border' onClick={getCancelDetails}>Get details</button>
      </div>

      {cancelDetails &&
        <AuthContext.Provider value={{member: member}}>
          {member && cancelDetails && !cancelDetails.cancellation.not_synced && (
            <CancellationProcessContext.Provider value={{cancelDetails: cancelDetails, setLoading: setLoading, plans: []}}>

              <div>
                <div>Cooldown period: {cancelDetails.cancellation.getCooldownDays()} days</div>
                <div>Minimum contract length: {cancelDetails.cancellation.getMandatoryDays()} days</div>
                <div>Notice period: {cancelDetails.cancellation.getNoticeDays()} days</div>
              </div>

              <CancellationFormComponent data={{}} />
            </CancellationProcessContext.Provider>
          )}
          {member && cancelDetails && cancelDetails.cancellation.not_synced && (
            <p className='red-text'>{props.t('membership_cancellation_not_synced_error')}</p>
          )}
        </AuthContext.Provider>
      }
    </div>
  );
}

export default withNamespaces()(CancellationTestComponent);